import { Navigate } from 'react-router-dom';

/**
 * HostRoute gates host-only pages. Treat presence of either a host profile or a valid access token
 * as authenticated to avoid redirect loops while host profile refetch is still in flight.
 */
const HostRoute = ({ isAuthed, token, loading, redirect = '/host/login', children }) => {
  const authed = isAuthed || !!token;
  if (loading) {
    return <div className="flex h-screen items-center justify-center text-slate-500">Loading...</div>;
  }
  if (!authed) return <Navigate to={redirect} replace />;
  return children;
};

export default HostRoute;
